module.exports = __webpack_public_path__ + "img/download_android.e24aa30c.png";